export const enWorkspaceAgentProbeQuota = {
  workspaceAgentProbeQuotaCredits: "Credits",
  workspaceAgentProbeQuotaCreditsRemaining: "{{amount}} Credits remaining",
  workspaceAgentProbeQuotaDollarRemaining: "${{amount}} remaining",
  workspaceAgentProbeQuotaRemaining: "{{percent}}% remaining"
} as const;
